/**
 * One-shot purge of double-encoded angular-auth-oidc-client state left over
 * from buggy versions of OidcLocalStorageService (PR #675 .. PR #683). Those
 * versions JSON.stringify'd values on write even though the library's default
 * DefaultLocalStorageService is a pure pass-through -- producing a JSON
 * string of a JSON string. After deploy of the fix, sessions still using a
 * corrupt cache would silently fail every forceRefreshSession() with
 * isAuthenticated:false (the library reads back a string where it expects
 * an object and treats it as "no auth state"), so 401s never recovered.
 *
 * Designed to run BEFORE anything else (Sentry init, Angular bootstrap,
 * AuthModule config) so the OIDC library sees a clean slate if corruption
 * is present. Safe to ship indefinitely -- it's a no-op on healthy state.
 *
 * Exported as a function so it can be unit-tested. Called from main.ts at
 * module-load time.
 */
export function purgeDoubleEncodedOidcState(): void {
    let corrupt = false;
    try {
        const raw = localStorage.getItem('0-em3-admin');
        if (raw === null) return;
        const parsed = JSON.parse(raw);
        // Healthy state is an object. A string here means the value was
        // double-encoded by a prior buggy storage service.
        if (typeof parsed !== 'string') return;
        corrupt = true;
        // eslint-disable-next-line no-console
        console.warn('Purging double-encoded OIDC state (legacy bug from PR #675/#683). User will be prompted to sign in.');
    } catch {
        // JSON.parse failure -- the value is malformed in some other way.
        // Wipe to recover.
        corrupt = true;
    }
    if (!corrupt) return;
    purgeOidcKeys();
}

function purgeOidcKeys(): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key && (key === '0-em3-admin' || key.startsWith('0-em3-admin.'))) {
            localStorage.removeItem(key);
        }
    }
}
